<app-move-to-status
  [dataSource]="dataSource"
  [displayedColumns]="displayedColumns"
  [subtitle]="subtitle"
  [title]="title"
  [showToListButton]="showToListButton"
  (close)="onCloseButtonClick()"
  [exportToExcelFileName]="exportToExcelFileName"
  (toListButtonClick)="onToListButtonClick()"
>
</app-move-to-status>
